import _ from 'lodash';
import { replaceHighlightTag } from '@patsnap-utils/highlight';
export const name = 'ARRAY_LINK.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const { PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    const links = _.map(cellValue, (content) => {
        return <span title={replaceHighlightTag(content)} 
        // @ts-ignore
        domProps={{ innerHTML: _highlightMixin_hlText(content) }} target="_blank" data-link-type={prop} data-link-data={content} data-patent-id={PATENT_ID} data-patent-no={PN}/>;
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {links}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const result = _.map(row[column.property] || [], item => {
        return item;
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
